import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_roots-32-learners/artifacts/uy0bpy4k_ChatGPT%20Image%20May%204%2C%202026%2C%2008_01_42%20PM.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#F2F0E9] border-t border-[#EBE8E0]">
      <div className="container-nova py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Tagline */}
          <div className="lg:col-span-2">
            <img 
              src={LOGO_URL} 
              alt="Nova Roots Schools" 
              className="h-36 w-auto object-contain mb-6"
            />
            <p className="text-[#5C6B6B] text-base leading-relaxed max-w-sm">
              32 learners. Two mixed-age pods. Structured mastery. Applied learning.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-medium uppercase tracking-wider text-[#1A3C34] mb-6">
              Explore
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/model" className="footer-link text-sm">The 2+4 Model</Link>
              <Link to="/academics" className="footer-link text-sm">Academics</Link>
              <Link to="/admissions" className="footer-link text-sm">Admissions</Link>
              <Link to="/founder" className="footer-link text-sm">Founder</Link>
              <Link to="/faq" className="footer-link text-sm">FAQ</Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm font-medium uppercase tracking-wider text-[#1A3C34] mb-6">
              Contact
            </h4>
            <div className="flex flex-col gap-3">
              <Link 
                to="/enquire" 
                className="btn-secondary inline-block text-center text-sm"
                data-testid="footer-enquire-btn"
              >
                Enquire Now
              </Link>
          <p className="text-[#5C6B6B] text-sm mt-4">
                Runda / Gigiri Corridor<br />
                <span className="font-medium text-[#1A3C34]">Nairobi, Kenya</span>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#EBE8E0] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#5C6B6B] text-sm">
            &copy; {currentYear} Nova Roots Schools. All rights reserved.
          </p>
          <p className="text-[#5C6B6B] text-sm">
            Opening September 2026
          </p>
        </div>
      </div>
    </footer>
  );
};
